import React from 'react'
import {get} from 'lodash'
import {withRouter, Redirect} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {Query} from 'react-apollo'

import {USER} from '../graphql/query'
import {selectProject} from './store/actions'

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      selectProject,
    },
    dispatch,
  )
}

export default Component => {
  const WithProjectHOC = props => {
    return (
      <Query query={USER}>
        {({loading, error, data}) => {
          if (loading) {
            return null
          }

          const {permissions, email} = data.me
          const projectId = get(props, 'match.params.projectId')
          const matchedProject = permissions.find(
            p => p.projectId === projectId,
          )

          if (projectId && matchedProject) {
            const project = {
              ...matchedProject,
              id: matchedProject.projectId,
              email,
            }
            props.selectProject(project)
            return <Component project={project} {...props} />
          }
          return <Redirect to="/projects" />
        }}
      </Query>
    )
  }

  return connect(null, mapDispatchToProps)(withRouter(WithProjectHOC))
}



// WEBPACK FOOTER //
// ./src/auth/withProject.js